module.exports = __webpack_public_path__ + "img/teacher_make_suggestion_button.a7f3fc8b.jpg";